import React from 'react';

const CTA: React.FC = () => {
  return (
    <section id="trial" className="section bg-blue-600 text-white">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="mb-6 text-3xl md:text-4xl font-semibold">Google口コミ管理を、今すぐ始めましょう</h2>
          <p className="text-blue-100 text-lg mb-8">
            AIを活用した口コミ管理で、顧客満足度を向上させませんか？
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a 
              href="#pricing"
              className="btn bg-white text-blue-600 hover:bg-gray-100 focus:ring-white w-full sm:w-auto"
            >
              今すぐ始める
            </a>
            <a 
              href="#features" 
              className="btn bg-white text-blue-600 hover:bg-gray-100 focus:ring-white w-full sm:w-auto"
            >
              デモを見る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;